import { produce } from 'immer'
import type { State } from '../typings'
import type { FiltersFormModel } from '../../../Filters'
import type { SchedulingScreen } from '../../../../typings'

export type ToResultsAction = {
  type: 'toResults'
  payload: {
    screen: Extract<SchedulingScreen, 'results'>
    values: FiltersFormModel
  }
}

export const toResultsAction = (
  state: State,
  payload: ToResultsAction['payload'],
) =>
  produce(state, (draft) => {
    const { screen, values } = payload
    const {
      startDate,
      endDate,
      startTime,
      endTime,
      duration,
      techId,
      techRegionId,
    } = values

    draft.loading = false
    draft.stack.push(screen)
    draft.response = undefined

    if (startDate !== null) draft.bestFitInput.startDate = startDate
    if (endDate !== null) draft.bestFitInput.endDate = endDate

    draft.bestFitInput.startTime = startTime ?? undefined
    draft.bestFitInput.endTime = endTime ?? undefined
    draft.bestFitInput.techRegionId = techRegionId
    draft.bestFitInput.techId = techId
    draft.bestFitInput.duration = `${duration}`
  })

export const toResultsActionCreator = (
  values: ToResultsAction['payload']['values'],
): ToResultsAction => ({
  type: 'toResults',
  payload: {
    screen: 'results',
    values,
  },
})
